import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useFeedback } from "@/contexts/feedback-context";
import React, { useState } from "react";

export const DislikeModal: React.FC = () => {
  const { modal, hideModal, submitFeedback, isSubmitting } = useFeedback();
  const [details, setDetails] = useState("");
  if (!modal.open || modal.type !== "dislike") return null;

  const handleSubmit = () => {
    if (!modal.contentType) return;
    submitFeedback({ ...modal.contentType, details }).then(() =>
      setDetails("")
    );
  };

  return (
    <Dialog open={modal.open} onOpenChange={hideModal}>
      <DialogContent>
        <DialogTitle>Feedback</DialogTitle>
        {!!modal.display && modal.display}
        <DialogDescription>
          Please provide details: (optional)
        </DialogDescription>
        <textarea
          className="w-full min-h-[80px] rounded border p-2 mt-2"
          placeholder="What was unsatisfactory about this response?"
          value={details}
          onChange={(e) => setDetails(e.target.value)}
        />
        <DialogFooter>
          <Button variant="outline" onClick={hideModal}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
